(() => {
  if (customElements.get('bd-event-message')) return;
  class PromotionMessage extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.product) return;
      const data = this.querySelector('[data-event-variants]');
      try { this.variants = new Map(JSON.parse(data?.textContent || '[]').map(v => [String(v.id), v.eligible])); }
      catch { this.hidden = true; return; }
      this.onVariant = event => {
        const section = event.target.closest('.shopify-section');
        if (section && !section.contains(this)) return;
        const variant = event.detail?.variant;
        this.hidden = !variant || this.variants.get(String(variant.id)) !== true;
      };
      document.addEventListener('on:variant:change', this.onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this.onVariant);
    }
  }
  customElements.define('bd-event-message', PromotionMessage);
})();

